/* Dharika — Scroll Reveal + Interaction Animations */

(function() {
  'use strict';

  // ── Scroll Reveal ──────────────────────────────────────────
  function initScrollReveal() {
    const cards = document.querySelectorAll('.card-wrapper');
    const sections = document.querySelectorAll('section h2, section h3, .collection__title, .section__heading');
    const productLists = document.querySelectorAll('.product-list, .collection-list, [class*="product-grid"]');

    // Tag cards with reveal classes and staggered delays
    cards.forEach(function(el, i) {
      el.classList.add('dharika-reveal');
      var delay = (i % 4);
      if (delay > 0) el.classList.add('dharika-delay-' + delay);
    });

    // Tag headings
    sections.forEach(function(el) {
      el.classList.add('dharika-reveal');
    });

    // Intersection observer
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.dharika-reveal, .dharika-reveal-left, .dharika-reveal-scale')
      .forEach(function(el) { observer.observe(el); });
  }

  // ── Header scroll shadow ───────────────────────────────────
  function initHeaderScroll() {
    var header = document.querySelector('header-component, .header-wrapper, header');
    if (!header) return;
    var scrolled = false;
    window.addEventListener('scroll', function() {
      var isScrolled = window.scrollY > 60;
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        header.classList.toggle('scrolled', scrolled);
      }
    }, { passive: true });
  }

  // ── Smooth image hover parallax on cards ──────────────────
  function initCardParallax() {
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      var img = card.querySelector('img');
      if (!img) return;
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = 'scale(1.07) translate(' + (x * 6) + 'px, ' + (y * 4) + 'px)';
      });
      card.addEventListener('mouseleave', function() {
        img.style.transform = '';
      });
    });
  }

  // ── Trust bar marquee (if exists) ─────────────────────────
  function initMarquee() {
    var bar = document.querySelector('.dharika-trust-bar--marquee');
    if (!bar) return;
    var inner = bar.querySelector('.trust-inner');
    if (!inner) return;
    var clone = inner.cloneNode(true);
    bar.appendChild(clone);
    var pos = 0;
    var speed = 0.4;
    (function tick() {
      pos -= speed;
      if (Math.abs(pos) >= inner.offsetWidth) pos = 0;
      bar.style.transform = 'translateX(' + pos + 'px)';
      requestAnimationFrame(tick);
    })();
  }

  // ── Collection image tilt ─────────────────────────────────
  function initTiltEffect() {
    document.querySelectorAll('.media--landscape, .collection-card, [class*="card__media"]').forEach(function(el) {
      el.addEventListener('mousemove', function(e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var tiltX = (y - 0.5) * 6;
        var tiltY = (x - 0.5) * -6;
        el.style.transform = 'perspective(600px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg)';
      });
      el.addEventListener('mouseleave', function() {
        el.style.transform = 'perspective(600px) rotateX(0deg) rotateY(0deg)';
        el.style.transition = 'transform 0.5s ease';
      });
    });
  }

  // ── Page load animation ───────────────────────────────────
  function initPageLoad() {
    document.body.style.opacity = '0';
    document.body.style.transition = 'opacity 0.5s ease';
    window.addEventListener('load', function() {
      document.body.style.opacity = '1';
    });
  }

  // ── Add gold ring to active nav ───────────────────────────
  function highlightActiveNav() {
    var path = window.location.pathname;
    document.querySelectorAll('.header__menu-item a, .header__menu > li > a').forEach(function(a) {
      if (a.getAttribute('href') === path) {
        a.style.color = 'var(--dharika-maroon)';
        a.style.fontWeight = '600';
      }
    });
  }

  // ── Init all ──────────────────────────────────────────────
  function init() {
    initPageLoad();
    initHeaderScroll();
    initScrollReveal();
    highlightActiveNav();
    // Slight delay for DOM with images
    setTimeout(function() {
      initCardParallax();
      initTiltEffect();
      initMarquee();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
